import {ExternalLink, Layout, Text} from '@eitje/web_components'

export const LinkRow = ({item}) => {
	return (
		<>
			<Text t={`records.default.fields.${item.description}`} infoIconMessage={item.infoIconMessage} />
			{Boolean(item.value) && (
				<Layout>
					<ExternalLink to={item.value} t="common.download" />
				</Layout>
			)}
		</>
	)
}
